const Storage = require('utils/storage');
const PersistenceConfig = require('utils/persistence-config');

module.exports = (store) => {

    Storage.session.subscribeStorePathWithStore(store, 'app.discoverSortType', PersistenceConfig.keys.app.discoverSortType);
    Storage.session.subscribeStorePathWithStore(store, 'app.discoverSearchFilter', PersistenceConfig.keys.app.discoverSearchFilter);
};
